import type { OrderInfo } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, QueryOptions, useLazyQuery, useQuery } from '@apollo/client'

import { SHORTCUT_BUSINESS_PROFILES_FIELDS, SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'

export interface FetchOrders {
  orders?: {
    edges: OrderInfo[]
    pageInfo: PageInfo
  }
}

export interface FetchOrdersVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
  allActive?: boolean
  pollInterval?: number
}

export const GQL_QUERY_FETCH_ORDERS = gql`
  query(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
    $allActive: Boolean
  ) {
    orders: allOrders(
      filter: $filter
      sort: $sort
      pager: $pager
      allActive: $allActive
    ) {
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
      edges {
        id
        status
        shop_id
        zone_id
        customer_phone
        customerGeoPoint {
          latitude
          longitude
        }
        totalCost
        total
        delivery_total
        saledCost
        address
        created_at
        takenByMe
        fullName
        feedbacks {
          id
        }
        shop {
          id
          name
          address
        }
        deliverySlot {
          id
          slotTime
          slotDate
          period {
            from
            to
          }
        }
        customer {
          id
          first_name
          last_name
          fullName
        }
        assembler {
          id
          first_name
          last_name
          phone
          status
          shop_id
          fullName
        }
        courier {
          id
          first_name
          last_name
          fullName
          phone
          status
        }
        operator {
          id
          first_name
          last_name
          fullName
          phone
          status
          email
        }
        placedAt
        assemblingStartedAt
        assemblingFinishedAt
        pickedByCourierAt
        deliveryStartedAt
        deliveryFinishedAt
        assembledOrderTotal
        assignedCustomerId
        totalDiscount
        businessProfile {
          ${SHORTCUT_BUSINESS_PROFILES_FIELDS}
        }
      }
    }
  }
`

export const useFetchOrders = (variables?: FetchOrdersVariables) => {
  return useQuery<FetchOrders, FetchOrdersVariables>(GQL_QUERY_FETCH_ORDERS, {
    variables,
    fetchPolicy: 'cache-and-network'
  })
}

export const useLazyFetchOrders = () => useLazyQuery<FetchOrders, FetchOrdersVariables>(GQL_QUERY_FETCH_ORDERS)